/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { Badge, Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import Session from './Session';

const CancelledSession = props => {

    // context
    const { theme, colors } = useContext(ThemeContext);

    // states
    const [isCancelledSessionOpen, setIsCancelledSessionOpen] = useState(false);
    const [sessionList, setSessionList] = useState([]);
    const [newCancelledSession, setNewCancelledSession] = useState([]);
    const [newRefundProcessed, setNewRefundProcessed] = useState([]);

    // utility functions
    const toggleCancelledSession = () => setIsCancelledSessionOpen(!isCancelledSessionOpen);

    // useEffect
    useEffect(() => {
        try {
            if (props.sessions) {
                setSessionList(props.sessions);
            }
            if (props.newCancelledSession) {
                setNewCancelledSession(props.newCancelledSession);
            }
            if (props.newRefundProcessed) {
                setNewRefundProcessed(props.newRefundProcessed);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User CancelledSession useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.sessions])

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card} id="cancelledSessions">
            <div className="row px-3" onClick={toggleCancelledSession} style={{ cursor: "pointer" }}>
                <span id="cancelledSessions" style={theme.headingBold}>Cancelled Sessions <Badge style={{ backgroundColor: colors.primary }}>{sessionList.length}</Badge> </span>

                {
                    sessionList.length ?
                        isCancelledSessionOpen
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i>{newRefundProcessed.length + newCancelledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newRefundProcessed.length + newCancelledSession.length}</Badge> : null}</span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i>{newRefundProcessed.length + newCancelledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newRefundProcessed.length + newCancelledSession.length}</Badge> : null}</span>
                        : null
                }

            </div>

            <Collapse isOpen={sessionList.length ? isCancelledSessionOpen : false}>
                <hr />
                {
                    sessionList.map((item, index) => (
                        <Session key={index} selectedTimeZone={props.selectedTimeZone} handleModal={props.handleModal} detail={item} type="Cancelled" index={index} newCancelledSession={newCancelledSession} newRefundProcessed={newRefundProcessed} />
                    ))
                }
            </Collapse>

        </div>
    )
}

export default CancelledSession;